var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9762 3.00033L9 1.02414C8.78572 0.809849 8.5 0.666992 8.19048 0.666992H1.80953C1.16667 0.666992 0.666672 1.1908 0.666672 1.80985V10.1908C0.666672 10.8337 1.16667 11.3337 1.80953 11.3337H10.1905C10.8095 11.3337 11.3333 10.8337 11.3333 10.1908V3.80985C11.3333 3.50033 11.1905 3.21461 10.9762 3.00033ZM6 9.80985C5.14286 9.80985 4.4762 9.14318 4.4762 8.28604C4.4762 7.45271 5.14286 6.76223 6 6.76223C6.83334 6.76223 7.52381 7.45271 7.52381 8.28604C7.52381 9.14318 6.83334 9.80985 6 9.80985ZM8.28572 2.57175V4.95271C8.28572 5.11937 8.14286 5.23842 8 5.23842H2.4762C2.30953 5.23842 2.19048 5.11937 2.19048 4.95271V2.47652C2.19048 2.33366 2.30953 2.1908 2.4762 2.1908H7.90477C7.9762 2.1908 8.04762 2.23842 8.11905 2.28604L8.19048 2.35747C8.2381 2.4289 8.28572 2.50033 8.28572 2.57175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.a9428260c59b512657407c1ea3514f15.svg";
export { ForwardRef as ReactComponent };